export type LineCap = 'butt' | 'round' | 'square';
export type LineJoin = 'round' | 'bevel' | 'miter';

export const closePointEps = 1e-4;
export const curveEps = 0.0001;
